import { TextSortBy } from "nystem-components";

const TinymceSortBy = (props) => <TextSortBy {...props} />;
export default TinymceSortBy;
